var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.product.crashingMessage) ? _c('div', {
    class: _vm.classes,
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    class: _vm.theme.controlWrap
  }, [(!_vm.product.isEnable) ? _c('v-font-icon', {
    directives: [{
      name: "margin",
      rawName: "v-margin.right",
      value: (2),
      expression: "2",
      modifiers: {
        "right": true
      }
    }],
    class: _vm.theme.errorIcon
  }, [_vm._v("\n                warning\n            ")]) : _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.right",
      value: (1),
      expression: "1",
      modifiers: {
        "right": true
      }
    }]
  }, [_c('v-radio', {
    class: [_vm.theme.control, _vm.isDisabledClass],
    attrs: {
      "value": _vm.value,
      "data": _vm.product
    }
  })], 1), _vm._v(" "), _c('v-text', {
    class: _vm.product.isEnable && _vm.isDisabledClass
  }, [_c('strong', [_vm._v(_vm._s(_vm.product.name) + ".")]), _vm._v(" " + _vm._s(_vm.product.crashingMessage) + "\n            ")])], 1)]) : _c('div', {
    class: _vm.classes,
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.product.isEnable) ? _c('div', {
    class: _vm.theme.controlWrap
  }, [_c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.right",
      value: (1),
      expression: "1",
      modifiers: {
        "right": true
      }
    }]
  }, [_c('v-radio', {
    class: [_vm.theme.control, _vm.isDisabledClass],
    attrs: {
      "value": _vm.value,
      "data": _vm.product
    }
  })], 1), _vm._v(" "), _c('v-text', {
    class: _vm.isDisabledClass
  }, [_vm._v("\n                " + _vm._s(_vm.product.name) + "\n            ")]), _vm._v(" "), (_vm.product.id !== -1) ? _c('v-link', {
    directives: [{
      name: "margin",
      rawName: "v-margin.left",
      value: (1),
      expression: "1",
      modifiers: {
        "left": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.right",
      value: (1),
      expression: "1",
      modifiers: {
        "right": true
      }
    }],
    class: _vm.theme.reportLink,
    attrs: {
      "to": _vm.getUrl('reportExample/' + _vm.product.id),
      "target": "_blank"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('v-font-icon', {
    attrs: {
      "small": "",
      "grey": ""
    }
  }, [_vm._v("info")])], 1) : _vm._e()], 1) : _c('div', {
    class: _vm.theme.controlWrap
  }, [_c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.right",
      value: (1),
      expression: "1",
      modifiers: {
        "right": true
      }
    }]
  }, [_c('v-radio', {
    class: [_vm.theme.control, _vm.isDisabledClass],
    attrs: {
      "value": _vm.value,
      "data": _vm.product
    }
  })], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "text": "Продукт будет доступен при прохождении идентификации.",
      "position": "top"
    }
  }, [_c('v-text', {
    class: _vm.isDisabledClass
  }, [_vm._v("\n                    " + _vm._s(_vm.product.name) + "\n                ")]), _vm._v(" "), _c('v-link', {
    directives: [{
      name: "margin",
      rawName: "v-margin.left",
      value: (1),
      expression: "1",
      modifiers: {
        "left": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.right",
      value: (1),
      expression: "1",
      modifiers: {
        "right": true
      }
    }],
    class: _vm.theme.reportLink,
    attrs: {
      "to": _vm.getUrl('reportExample/' + _vm.product.id),
      "target": "_blank"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('v-font-icon', {
    attrs: {
      "small": "",
      "grey": ""
    }
  }, [_vm._v("info")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    class: _vm.theme.productCount
  }, [(_vm.product.freeCount) ? _c('v-label', {
    directives: [{
      name: "margin",
      rawName: "v-margin.right",
      value: (2),
      expression: "2",
      modifiers: {
        "right": true
      }
    }],
    class: _vm.isDisabledClass,
    attrs: {
      "orange": ""
    }
  }, [_vm._v("\n                Бесплатно " + _vm._s(_vm.product.freeCount) + " " + _vm._s(_vm.declOfNum(_vm.product.freeCount, ['запрос', 'запроса', 'запросов'])) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.product.id !== -1) ? _c('v-text', {
    class: _vm.isDisabledClass,
    attrs: {
      "nowrap": ""
    }
  }, [_vm._v("\n                " + _vm._s(_vm.product.availableCount) + " шт\n            ")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.addSeparator) ? _c('v-separator') : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-409ff990","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/requestProduct/RequestProduct.vue
// module id = 1061
// module chunks = 0